import * as angular from 'angular';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts/highstock';
import * as moment from 'moment';
import template from './dumpGateTimeReport.tpl.html';
import {StateParams} from "../../../common";
import {apsViewModels} from "../../../shared/dto/APS.ViewModels";
import UIUtilityServiceName, {UIUtilityService} from "../../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../../services/reports/report.service";
import DateUtilityService from "../../../services/utility/dateutility.service";
import {States} from "../../../shared/config/constant.module";
import NavigationServiceName, {NavigationService} from "../../../services/navigation/navigation.service";
import { Plant } from '../../../models/navigation';
import { PlantService } from '../../../services/plant/plant.service';


let requires = [UIUtilityServiceName, LoaderServiceName, ReportServiceName, NavigationServiceName];

interface DumpGateTimeReportCtrl {
  reportDate: Date;
  plants: Plant[];
  shiftPlants: apsViewModels.PlantInfo[];
  selectedPlant: Plant;
  form: angular.IFormController;

  getReport(): void;
}

interface Shift {
  id: string;
  name: string;
}

export interface DumpGateTimeReportParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
}

class DumpGateTimeReportCtrl implements DumpGateTimeReportCtrl {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  shifts: Shift[];
  selectedShift: Shift;
  shiftPlants: apsViewModels.PlantInfo[];
  startDate: Date;
  endDate: Date;
  reportStartDate: Date = new Date();
  reportEndDate: Date = new Date();

  reportShopId: string;
  reportShopName: string;
  reportTimeZoneId: string;
  reportShiftId: string;
  reportShiftName: string;

  form: angular.IFormController;

  searchPerformed: boolean;
  dumpGateTimeItems: apsViewModels.DumpGateTimeReportItem[];
  reportTotalDuration: number;
  reportTotalEvents: number;

  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  uiUtilityService: UIUtilityService;

  scopeWorkaround: {
    downtimeBarClick(dimpleEvent: {
      xValue: string;
      seriesValue: string[];
    }): void;
  };

  requirePlantSelection: boolean;
  requireShopSelection: boolean;
  private $q: angular.IQService;
  private $stateParams: DumpGateTimeReportParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: DumpGateTimeReportParams,
    navigationService: NavigationService,
    plantService: PlantService,
    reportService: ReportService,
    loaderService: LoaderService,
    uiUtilityService: UIUtilityService,
    $q: angular.IQService,
    ) {

    let vm = this;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.uiUtilityService = uiUtilityService;
    this.$q = $q;
   
    this.reportEndDate.setHours(7);
    this.reportEndDate.setMinutes(0);
    this.reportEndDate.setSeconds(0);

    this.reportStartDate.setDate(this.reportEndDate.getDate() - 1);
    this.reportStartDate.setHours(7);
    this.reportStartDate.setMinutes(0);
    this.reportStartDate.setSeconds(0);

    var navPromise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;
      this.selectedShop = navModel.selectedShop;
    });

    var plantsPromise = plantService.getPlants().then(plants => {
      this.shiftPlants = plants;
    });

    var promise = $q.all([navPromise, plantsPromise]).then(() => {
      this.updatePlant();

      this.loadState($stateParams);

      return this.generateReport();
    });

    loaderService.loadingPromise(promise);
 }

 updatePlant() {
  var shiftPlant = this.shiftPlants.filter(p => p.id === this.selectedPlant.id)[0];
    this.shifts = shiftPlant.shiftSchedules.map((s) => {
      return {
        id: s.id,
        name: s.name
      };
    });
  }

  loadState(params: DumpGateTimeReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        var shop = _.find(plant.shops, {id: params.reportShopId});
        if (shop) {
          this.selectedPlant = plant;
          this.selectedShop = shop;
        }
      }
    }

    if (params.startDate){
      this.reportStartDate =  new Date(params.startDate);
    }

    if (params.endDate) {
      this.reportEndDate = new Date(params.endDate);
    }
    return this.$q.when();
  }

  saveState() {
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }
    let params: DumpGateTimeReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      reportShopId: reportShopId,
      startDate: this.reportStartDate ? this.reportStartDate.toString() : undefined,
      endDate: this.reportEndDate ? this.reportEndDate.toString() : undefined,
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport() {
    if (this.form.$invalid) {
      return;
    }

    this.saveState();

    this.loaderService.loadingPromise(this.runDumpGateTimeReport());
  }

  private runDumpGateTimeReport(): angular.IPromise<any> {
    if (this.selectedShop == null) {
      this.reportShopId = '';
      this.reportShopName = '';
    } else {
      this.reportShopId = this.selectedShop.id;
      this.reportShopName = this.selectedShop.name;
    }

    if (this.selectedShift == null) {
      this.reportShiftId = '';
      this.reportShiftName = '';
    } else {
      this.reportShiftId = this.selectedShift.id;
      this.reportShiftName = this.selectedShift.name;
    }
    this.reportTimeZoneId = this.selectedPlant.timeZoneId;
    this.dumpGateTimeItems = null;
    this.searchPerformed = false;

    let promise = this.reportService.getDumpGateTimeReport(this.selectedPlant.id, this.reportShopId, this.reportShiftId,
      this.reportStartDate, this.reportEndDate);

    promise.then((data) => {
      this.searchPerformed = true;
      
      if (data === null || data.length === 0) {
        return;
      }
      this.dumpGateTimeItems = data;
      this.reportTotalDuration = data.reduce(
        (accumulator, currentValue) => accumulator + currentValue.totalSeconds, 0
      );
      this.reportTotalEvents = data.reduce(
        (accumulator, currentValue) => accumulator + currentValue.timesOpened, 0
      );
      this.createChart('chart_area', this.getChartSeries(this.buildSeries(this.dumpGateTimeItems, this.reportStartDate, this.reportEndDate)));
    });

    return promise;
  }

  private buildSeries(data: apsViewModels.DumpGateTimeReportItem[], startDate:Date, endDate:Date):apsViewModels.DumpTimeSeries[] {
    let series: apsViewModels.DumpTimeSeries[]= [];
    const uniqueShops = _.uniq(data.map(d => d.shopName)).sort();
    uniqueShops.forEach(shop => {

      let shopData = data.filter(d => d.shopName === shop);
      let shopSeries = [];

      for (let currentdate = new Date(startDate.toDateString()); currentdate < endDate; currentdate.setDate(currentdate.getDate() + 1)) {

        let dateElements = shopData.filter(x => x.dbDate.toDateString() === currentdate.toDateString());
        shopSeries.push({
            dbDate: new Date(currentdate.toDateString()),
            totalSeconds: dateElements.reduce((sum, current) => sum + current.totalSeconds/60, 0)
          });
      }

      series.push({
        plantName: data[0].plantName,
        shopName: shop,
        details: shopSeries
      });
    });   

    return series;
  }

  formatTime(time: Date): string {
    return DateUtilityService.formatTime(time, this.selectedPlant.timeZoneId); 
  }

  formatDuration(totalSeconds: number): string {
    return totalSeconds/3600 - (totalSeconds/3600%1) + ":" + moment(totalSeconds *1000).format("mm:ss"); 
  }

  getChartSeries(data: apsViewModels.DumpTimeSeries[]): any[] {
    let seriesOptions = [];
    let i = 0;

   data.forEach(series => {
      let items = [];

      series.details.forEach(item => {
        let datapoint = {
          x: item.dbDate,
          y: item.totalSeconds
        };

        items.push(datapoint);
      });

      seriesOptions[i] = {
        name: series.shopName,
        data: items
      }
      i++;
    });

    return seriesOptions;
  }

  createChart(containerId: string, seriesOptions: any[]) {
    Highcharts.chart(containerId,
    {
      title: {
        text: this.selectedPlant.name + " Dump Gate Time by Date"
      },
      time: {
        useUTC: false
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        },
        tickInterval: 24 * 3600 * 1000,
        dateTimeLabelFormats: {
          second: '%l:%M:%S %p',
          minute: '%l:%M %p',
          hour: '%l %p',
          day: '%m/%d/%Y',
          month: '%m/%d/%Y',
          year: '%m/%d/%Y'
        }
      },
      tooltip: {
        formatter: function () {
          return moment(this.x).format("MM/DD/YYYY") + "<br/>" + this.series.name + ": <strong>" + this.y.toFixed(2) + "</strong>"
        } 
      },
      yAxis: {
        labels: {
          formatter: function () {
            return (this.value > 0 ? ' + ' : '') + this.value.toFixed(2);
          }
        },
        title: {
          text: 'Time in Minutes'
        },
        plotLines: [{
          value: 0,
          width: 2,
          color: 'silver'
        }]
      },
      series: seriesOptions,
      credits: { enabled: false }
    });
  }

  exportToCsv() { 
    let shopName = this.reportShopName !== "" ? this.reportShopName :'All';

    let result = "Local Time, Plant, Tank, Shop, Shift, Duration, Dump Events";
    result += "\n";
    this.dumpGateTimeItems.forEach(row => {
      result += '"' + this.formatTime(row.dbDate) + '",';
      result += '"' + row.plantName + '",';
      result += '"' + row.tankName + '",';
      result += '"' + row.shopName + '",';
      result += '"' + row.shiftName + '",';
      result += '"' + this.formatDuration(row.totalSeconds) + '",';
      result += '"' + row.timesOpened + '"';
      result += "\n";
    });
    result += '"","","","",Total,';
    result += '"' + this.formatDuration(this.reportTotalDuration) + '",';
    result += '"' + this.reportTotalEvents + '"' + "\n";

    var a = document.createElement("a");
    a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(result);
    a.target = '_blank';
    a.download = this.dumpGateTimeItems[0].plantName +'_' + shopName+'_DumpTime_'+ moment(this.startDate).format("MM_DD_YYYY") + '.csv';
    document.body.appendChild(a);
    a.click();
  }

}


export default angular.module('aps.controller.dumpGateTimeReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.DUMPGATETIME_REPORT,
      url: '/admin/reports/dumpgatetime?startDate&endDate&reportPlantId&reportShopId',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
      },
      controller: 'DumpGateTimeReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Dump Gate Time Report'
      }
    });
  })
  .controller('DumpGateTimeReportCtrl', DumpGateTimeReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/dumpGateTimeReport/dumpGateTimeReport.controller.ts